<div id="modal-content-wrapper" class="modal-error">
  <div mat-dialog-content>
    <span>{{modalData.error}}</span>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-end text-white">
    <button mat-raised-button mat-dialog-close color="primary" (click)="closeModal()">Chiudi</button>
  </div>
</div>
